import { useEffect, useState } from "react";
import { onNotification, type Notification } from "../lib/api-events";

const DURATION = 3000;

export function Notifications() {
  const [toasts, setToasts] = useState<Notification[]>([]);

  useEffect(() => {
    return onNotification((notification) => {
      setToasts((prev) => [...prev, notification]);
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== notification.id));
      }, DURATION);
    });
  }, []);

  if (toasts.length === 0) return null;

  return (
    <div className="fixed top-3 right-3 z-50 flex flex-col gap-2">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`rounded-xl px-4 py-3 text-sm font-medium shadow-lg transition-all animate-in ${
            toast.type === "success"
              ? "bg-emerald-600 text-white"
              : "bg-rose-600 text-white"
          }`}
        >
          {toast.type === "success" ? "✓ " : "✕ "}
          {toast.message}
        </div>
      ))}
    </div>
  );
}
